import type { JSX } from "react";
import { alpha, CardHeader, Divider, IconButton, Typography, useTheme } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { FormattedMessage, MessageDescriptor } from "react-intl";

interface IProps {
    close: () => void;
    title: string | MessageDescriptor | JSX.Element;
    icon?: JSX.Element;
}

function renderTitle(title) {
    switch (typeof title) {
        case "string":
            return <Typography sx={{ fontSize: "18px" }}>{title}</Typography>;
        case "object":
            if (Object.hasOwn(title, "id") && Object.hasOwn(title, "defaultMessage")) {
                return (
                    <div style={{ fontSize: "18px" }}>
                        <FormattedMessage {...title} />
                    </div>
                );
            }

            return <div style={{ fontSize: "18px" }}>{title}</div>;
        default:
            return null;
    }
}

const FlyInDrawerHeader = ({ close, icon, title }: IProps) => {
    const theme = useTheme();
    return (
        <div style={{ position: "sticky", top: 0, backgroundColor: theme.palette.background.paper, zIndex: 2 }}>
            <CardHeader
                action={
                    <IconButton onClick={close} sx={{ color: alpha(theme.palette.ink.main, 0.6), cursor: "pointer" }} aria-label="Close drawer">
                        {icon || <CloseIcon />}
                    </IconButton>
                }
                title={renderTitle(title)}
            />
            <Divider />
        </div>
    );
};

export default FlyInDrawerHeader;
